import { fetchExtraProductOfferInfo } from './fetch-extra-product-offer-info.js';
import { BRAND_NAME } from "./meta.js";

/**
 * @typedef {Object} ProductImage
 * @property {string} IMAGE_SRC
 * @property {string} IMAGE_SRC_2X
 * @property {string} IMAGE_SRC_ORIGINAL
 */

/**
 * @typedef {Object} ProductItem
 * @property {string} id
 * @property {string} productId
 * @property {string} name
 * @property {string} catalogLink
 * @property {string} imageLink
 * @property {number} quantity
 * @property {number} availableQuantity
 * @property {string} priceFormatted
 * @property {string} price
 * @property {string} oldPriceFormatted
 * @property {string} oldPrice
 * @property {string} discountValueFormatted
 * @property {ProductImage[]} images
 * @property {Object.<string, string>} basketProperties
 */

/**
 * Creates products array from store
 * @param {ProductItem[]} items
 * @returns {*}
 */
export function productsFromStore(items) {
    return fetchExtraProductOfferInfo(items.map(item => item.productId))
        .then((itemExtraInfo) => {
            return itemExtraInfo.reduce((accumulator, extraInfo) => {
                return accumulator.set(extraInfo.id, extraInfo);
            }, new Map())
        })
        .then((/** Map<string, ProductExtraInfo> */itemExtraInfoMap) => {
            return items.map((item) => ({
                'id': item.basketProperties[BX.message('KZ_DATA_LAYER_PROPERTY_XML_ID')],
                'bitrixID': item.productId,
                'name': item.name,
                'price': item.price,
                'brand': BRAND_NAME,
                /** Duplicate - NK-567 ( https://new-kanzler.atlassian.net/browse/NK-567 ) */
                'catName': itemExtraInfoMap.get(item.productId).elementSectionName,
                'catID': itemExtraInfoMap.get(item.productId).elementSectionId,
                'category': itemExtraInfoMap.get(item.productId).elementSectionPath,
                'categoryId': itemExtraInfoMap.get(item.productId).elementSectionId,
                'variant': item.basketProperties[BX.message('KZ_DATA_LAYER_PROPERTY_SIZE')],
                'quantity': item.quantity,
                'count': item.quantity,
            }));
        })
}